import React from "react";
import { FileText, Lock, FileCheck2 } from "lucide-react";
import { Card } from "@/components/ui/Card";
import { Stagger, StaggerItem } from "@/components/motion/Stagger";
import { useT } from "@/hooks/useT";

const ICONS = { "01": FileText, "02": Lock, "03": FileCheck2 };

/**
 * Three-step strip: 01 Published · 02 Sealed · 03 Check.
 * Outlined-variant cards on dark surface, lucide icons in violet.
 */
export function ThreeStepStrip() {
  const { t } = useT("verifiedDocuments");
  const steps = ["step1", "step2", "step3"];

  return (
    <section
      className="border-t border-hairline py-16 md:py-20"
      data-testid="verified-steps"
    >
      <div className="mx-auto max-w-6xl px-6">
        <p className="mb-10 text-[12px] font-semibold uppercase tracking-caps text-eyebrow">
          {t("steps.section")}
        </p>
        <Stagger gap={70} className="grid gap-5 md:grid-cols-3">
          {steps.map((key) => {
            const num = t(`steps.${key}.number`);
            const Icon = ICONS[num] || FileText;
            return (
              <StaggerItem key={key}>
                <Card variant="outlined" className="h-full border-hairline bg-transparent text-frac-white">
                  <div className="flex items-start justify-between">
                    <span className="font-mono text-sm font-semibold text-frac-violet">
                      {num}
                    </span>
                    <Icon
                      className="h-5 w-5 text-frac-violet"
                      strokeWidth={1.75}
                      aria-hidden
                    />
                  </div>
                  <h3 className="mt-6 text-xl font-semibold leading-snug tracking-tight">
                    {t(`steps.${key}.title`)}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-ink-secondary">
                    {t(`steps.${key}.caption`)}
                  </p>
                </Card>
              </StaggerItem>
            );
          })}
        </Stagger>
      </div>
    </section>
  );
}

export default ThreeStepStrip;
